<!-- TODO: da completare -->
<div class="it-hero-wrapper it-dark it-overlay it-bottom-overlapping-content">
    <div class="img-responsive-wrapper">
        <div class="img-responsive">
            <div class="img-wrapper">
                <img src="assets/img/tmp-viewer-hero.jpg" title="img title" alt="Immagine hero" />
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row justify-content-end">
            <div class="col-4">
                <div class="it-hero-text-wrapper bg-dark pr-0">
                    <div class="it-hero-text-inner">
                        <h1>Opere di Difesa del Suolo - Viewer</h1>
                        <p class="d-none d-lg-block">
                            Platea dictumst vestibulum rhoncus est pellentesque elit ullamcorper
                            dignissim cras. Dictum sit amet justo donec enim diam vulputate ut.
                            Eu nisl nunc mi ipsum faucibus.
                        </p>
                        <div class="it-btn-container">
                            <button class="btn btn-lg btn-primary" type="button" (click)="goToViewer()">Accedi al viewer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container">
    <div class="row">
        <div class="col-12">
            <div class="card-wrapper card-space">
                <div class="card card-bg">
                    <div class="card-body">
                        <h5 class="card-title">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                            eiusmod tempor…
                        </h5>
                        <p class="card-text">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                            eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem
                            ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                            tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum
                            dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                            incididunt ut labore et dolore magna aliqua.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row my-5">
        <div class="col-12 col-lg-4">
            <div class="callout important">
                <div class="callout-title">
                    <app-toolkit-bl-icon icon="info-circle"></app-toolkit-bl-icon>
                    Lorem ipsum dolor
                </div>
                <p>Quisque ex eros, pellentesque vitae enim sed, pharetra tempus dolor. Donec eu nibh ac lacus luctus pellentesque. Duis interdum scelerisque magna nec malesuada.</p>
            </div>
        </div>
        <div class="col-12 col-lg-4">
            <div class="callout important">
                <div class="callout-title">
                    <app-toolkit-bl-icon icon="info-circle"></app-toolkit-bl-icon>
                    Lorem ipsum dolor
                </div>
                <p>Quisque ex eros, pellentesque vitae enim sed, pharetra tempus dolor. Donec eu nibh ac lacus luctus pellentesque. Duis interdum scelerisque magna nec malesuada.</p>
            </div>
        </div>
        <div class="col-12 col-lg-4">
            <div class="callout important">
                <div class="callout-title">
                    <app-toolkit-bl-icon icon="info-circle"></app-toolkit-bl-icon>
                    Lorem ipsum dolor
                </div>
                <p>Quisque ex eros, pellentesque vitae enim sed, pharetra tempus dolor. Donec eu nibh ac lacus luctus pellentesque. Duis interdum scelerisque magna nec malesuada.</p>
            </div>
        </div>
    </div>
</div>